export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/makers_experience_perseus/apps/Illustration-value-4.fcf5e66.svg";